import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { HolidayClosureService } from './holiday-closure.service';
import { BannerType } from '@wcg/frontend-framework';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MaintenanceService } from '@data-access/system-controls/maintenance';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'holiday-closure',
  standalone: false,
  styleUrls: ['./holiday-closure.component.css'],
  templateUrl: './holiday-closure.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolidayClosureComponent implements OnInit {
  private _holidayClosureService = inject(HolidayClosureService);
  private _destroyRef = inject(DestroyRef);
  holidayName: string | null = null;
  holidayDate: string | null = null;
  doubleHolidayStart: string | null = null;
  doubleHolidayEnd: string | null = null;
  doubleHoliday: boolean = false;
  closeButton: boolean = true;
  warningBannerType = BannerType.WARNING;

  private _maintenanceService: MaintenanceService = inject(MaintenanceService);

  async ngOnInit(): Promise<void> {
    await this._loadUpComingHoliday();
  }

  handOnClose(): void {
    this.closeButton = false;
  }

  private async _loadUpComingHoliday() {
    try {
      // Don't load holidays if system is in maintenance mode
      const status = await firstValueFrom(this._maintenanceService.getStatus());
      if (status.active) {
        console.log(
          '[HolidayClosureComponent] Skipping holiday load - maintenance mode active',
        );
        return;
      }
    } catch (error) {
      console.error(
        '[HolidayClosureComponent] Error checking maintenance status:',
        error,
      );
    }

    this._holidayClosureService
      .getUpcomingHoliday()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((holiday) => {
        if (holiday) {
          this.holidayName = holiday.name ?? '';
          this.doubleHoliday = !holiday.single;

          if (holiday.single) {
            this.holidayDate = holiday.start_date;
          } else {
            this.doubleHolidayStart = holiday.start_date;
            this.doubleHolidayEnd = holiday.end_date;
          }
        }
      });
  }
}
